import { randomDelay } from "@/lib/utils/sleep";

export interface DashboardSummary {
  totalVgv: number;
  totalVgl: number;
  activeDealsCount: number;
  newLeadsCount: number;
  conversionRate: number;
}

export async function getDashboardSummary(): Promise<DashboardSummary> {
  await randomDelay();
  return {
    totalVgv: 15250000.00,
    totalVgl: 48500.00,
    activeDealsCount: 128,
    newLeadsCount: 452,
    conversionRate: 12.8,
  };
}
